import { Injectable } from '@angular/core';
import { HttpInterceptor,HttpHandler,HttpRequest,HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var user = JSON.parse(sessionStorage.getItem("userinfo"));
    if(user == null)
      return next.handle(request);

    if (request.url.includes('/api/user/getAccessToken') || request.url.includes('/api/user/login') || request.url.indexOf('/api/') === -1 || request.headers.get("APIDocumentation")) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: {
        userEmailId: JSON.parse(sessionStorage.getItem("userinfo")).userEmailId,
        ApplicationID:'VAL Web App',
        Authorization: sessionStorage.getItem("authentication")
      }
    });
    return next.handle(request);
  }
  constructor() { }
}
